(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/suspensionhistory.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/suspensionhistory.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.SuspensionHistory = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.suspensionhistory(data);
    },
    behaviors: {
      ServerSideRendering: {}
    },

    regions: {
      suspensionHistoryList: {
        el: '#suspensionHistoryList',
        replaceElement: true
      }
    },

    onRender: function() {
      this.showChildView(
        'suspensionHistoryList',
        new svs.spelpaus.views.SuspensionHistoryList({
          collection: this.collection
        })
      );
    }
  });
})(Backbone, _, svs);

 })(window);